export const planOtbHeader = [
  {
    group: 'Empresa',
    columns: [
      // {
      //   name: 'Periodo',
      //   id: 'empresa-periodo-id',
      //   show: true
      // },
      {
        name: 'Ano',
        id: 'empresa-ano',
        show: true
      },
      {
        name: 'Mes',
        id: 'empresa-mes',
        show: true
      },
      {
        name: 'Código',
        id: 'empresa-codigo-id',
        show: true
      }
    ]
  },
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Código',
        id: 'categoria-compacta-codigo-id',
        show: true
      }
      // {
      //   name: 'Descrição',
      //   id: 'categoria-compacta-descricao-id',
      //   show: true
      // }
    ]
  },
  {
    group: 'Categoria',
    columns: [
      {
        name: 'Código',
        id: 'categoria-codigo-id',
        show: true
      }
      // {
      //   name: 'Descrição',
      //   id: 'categoria-descricao-id',
      //   show: true
      // }
    ]
  },
  {
    group: 'Indicadores (R$)',
    columns: [
      {
        name: 'Estoque Inicial',
        id: 'indicadores-estoque-inicial-id',
        show: true
      },
      {
        name: 'A Receber',
        id: 'indicadores-a-receber-id',
        show: true
      },
      // {
      //   name: 'Vd Planej. PCL',
      //   id: 'indicadores-planej-pcl-id',
      //   show: true
      // },
      {
        name: 'Venda Projetada.',
        id: 'indicadores-planej-projet-id',
        show: true
      },
      {
        name: 'Compra Projet.',
        id: 'indicadores-compra-projet-id',
        show: true
      },
      {
        name: 'Estoque Final',
        id: 'indicadores-estoque-final-id',
        show: true
      },
      {
        name: 'Estoque Final Ajust',
        id: 'indicadores-estoque-final-ajust-id',
        show: true
      }
    ]
  }
]
